import React from 'react'
import { useForm } from 'react-hook-form'
import { sendEmailResetPassword } from '../../redux/actions/login'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import getConfigDetails  from '../../services/config'
import { emailRegEx, getErrorMessage } from '../../utils/helper'

const Forgotpassword = ({ notify, dispatch }) => {
  // Sending URL with partner
  const partner = window.location.toString().split('/')
  const { register, handleSubmit, formState: { errors } } = useForm()

  const onSubmit = (data) => {
    partner.pop()
    let formData = {
      email: data?.email,
      client_secret: getConfigDetails.CLIENT_SECRET,
      base_url: partner.join('/'),
    }
    dispatch(sendEmailResetPassword(formData)).then((res) => {
      if (res?.status == '201') {
        notify('success', res?.data?.message)
      } else {
        notify('error', getErrorMessage(res))
      }
    })
  }
  return (
    <div>
      <div className='container d-flex flex-column'>
        <div className='row align-items-center justify-content-center
            'style={{minHeight:'calc(100vh - 120px)'}}>
          <div className='col-12 col-md-8 col-lg-4'>
            <div className='card shadow-sm'>
              <div className='card-body'>
                <div className='mb-4'>
                  <h5>Forgot Password?</h5>
                  <p className='mb-2'>Enter your registered email ID to reset the password
                  </p>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className='mb-3'>
                    <label htmlFor='email' className='form-label'>Email</label>
                    <input
                      type='email'
                      id='email'
                      className='form-control'
                      name='email'
                      placeholder='Enter Your Email'
                      required=''
                      // ref={register({ required: true, maxLength: 20 })}
                      {...register('email', {
                        required: true,
                        pattern: { value: emailRegEx, message: 'invalid email address' }
                      })}
                    />
                    {errors?.email && <>
                      {errors.email.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                      {errors.email.type === 'pattern' && <span style={{ color: 'red' }}>{errors?.email?.message}</span>}
                    </>}
                  </div>
                  <div className='mb-3 d-grid'>
                    <button type="submit" className='btn btn-primary'>
                      Reset Password
                    </button>
                  </div>
                  {/* <span>Don't have an account? <a href="sign-in.html">sign in</a></span> */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}



Forgotpassword.propTypes = {
  dispatch: PropTypes.func,
  notify: PropTypes.func,
  isLoading: PropTypes.bool
}

Forgotpassword.defaulProps = {
  dispatch: noop,
  notify: noop,
  isLoading: false
}

function mapStateToProps({ loginReducer }) {
  return {
    isLoading: loginReducer?.loader
  }
}
export default connect(mapStateToProps)(Forgotpassword)
